import { Component, Story, Knobs } from './DocTypes';
import { TagMobileSideMenuOptionDocs } from './TagMobileSideMenuOptionDocs';

const BasicStoryKnobs: Knobs = {
  heading: { default: 'Simple Popover', editor: 'textbox' },
  showBackButton: { default: false, editor: 'checkbox' },
  'colour-scheme': {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', ''],
    default: '',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A side menu for mobile apps',

  coreComponent_v3: {
    html: `<tag3-mobile-side-menu data-name="mainMenu" {{...knobs}}>
  <tag3-text text='Security Settings' type='feature' device='mobile'></tag3-text>
  <tag3-mobile-side-menu-option text="Biometric Authentication" icon="ThumbsUp" type="toggle" accent="keppel"></tag3-mobile-side-menu-option>
  <tag3-mobile-side-menu-option text="Reset Pin" icon="Refresh" accent="keppel"></tag3-mobile-side-menu-option>
  <tag3-mobile-side-menu-option text="Disabled Option" icon="NoEntry" accent="keppel" type="toggle" disabled></tag3-mobile-side-menu-option>
  <br />
  <tag3-mobile-side-menu-option text="Sign Out" icon="Exit" accent="keppel" data-name='close'></tag3-mobile-side-menu-option>
</tag3-mobile-side-menu>
<div style="padding: 16px;">
  <tag3-simple-button data-name='open' {{colour-scheme}}>Open</tag3-simple-button>
</div>
`,
    js: `var openButton = document.querySelector('tag3-simple-button[data-name="open"]');
var closeButton = document.querySelector('tag3-mobile-side-menu-option[data-name="close"]');

openButton.addEventListener("buttonClick", function () {
  var modal = document.querySelector('tag3-mobile-side-menu[data-name="mainMenu"]');
  modal.open = true;
});
closeButton.addEventListener("optionClick", function () {
  var modal = document.querySelector('tag3-mobile-side-menu[data-name="mainMenu"]');
  modal.open = false;
});
`,
    knobs: {
      position: {
        editor: 'dropdown',
        editorOptions: ['left', 'right', ''],
        default: 'right',
      },
      ...BasicStoryKnobs,
    },
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <TagMobileSideMenu open={open} {{...knobs}} onClosed={() => setOpen(false)}>
        <Tag3Text text='Security Settings' type='feature' device='mobile'></Tag3Text>
        <TagMobileSideMenuOption text="Biometric Authentication" icon="ThumbsUp" type="toggle" accent="keppel" />
        <TagMobileSideMenuOption text="Reset Pin" icon="Refresh" accent="keppel" />
        <TagMobileSideMenuOption text='Disabled' icon='NoEntry' accent='keppel' type='toggle' disabled />
        <br />
        <TagMobileSideMenuOption text='Sign Out' icon='Exit' accent='keppel' type='button' onOptionClick={() => setOpen(false)} />
      </TagMobileSideMenu>
      <div style={{padding: "16px" }}>
        <Tag3SimpleButton
          onButtonClick={() => setOpen(true)}
        {{colour-scheme}}>
          Open
        </Tag3SimpleButton>
      </div>
    </>
  )
}
`,
    knobs: {
      position: {
        editor: 'dropdown',
        editorOptions: ['left', 'right', ''],
        default: 'right',
      },
      ...BasicStoryKnobs,
    },
  },
};

const MultiLayerStory: Story = {
  title: 'Child Menu',
  description: 'Open child menu from top menu',

  coreComponent_v3: {
    html: `<tag3-mobile-side-menu data-name="mainMenu" {{...knobs}}>
  <tag3-mobile-side-menu-option text="Settings" icon="Settings" accent="keppel" data-name='openChild'></tag3-mobile-side-menu-option>
  <tag3-mobile-side-menu-option text="Disabled Option" icon="NoEntry" accent="keppel" type="toggle" disabled></tag3-mobile-side-menu-option>
  <tag3-mobile-side-menu-option text="Sign Out" icon="Exit" accent="keppel" data-name='close'></tag3-mobile-side-menu-option>
</tag3-mobile-side-menu>
<tag3-mobile-side-menu data-name="childMenu" {{...knobs}} heading="Settings" show-back-button="true">
  <tag3-text text='Security Settings' type='feature' device='mobile'></tag3-text>
  <tag3-mobile-side-menu-option text="Biometric Authentication" icon="ThumbsUp" type="toggle" accent="keppel"></tag3-mobile-side-menu-option>
  <tag3-mobile-side-menu-option text="Reset Pin" icon="Refresh" accent="keppel"></tag3-mobile-side-menu-option>
</tag3-mobile-side-menu>
<div style="padding: 16px;">
  <tag3-simple-button data-name='open' {{colour-scheme}}>Open</tag3-simple-button>
</div>
`,
    js: `var openButton = document.querySelector('tag3-simple-button[data-name="open"]');
var closeButton = document.querySelector('tag3-mobile-side-menu-option[data-name="close"]');
var openChildButton = document.querySelector('tag3-mobile-side-menu-option[data-name="openChild"]');
var childMenu = document.querySelector('tag3-mobile-side-menu[data-name="childMenu"]');

openButton.addEventListener("buttonClick", function () {
  var modal = document.querySelector('tag3-mobile-side-menu[data-name="mainMenu"]');
  modal.open = true;
});
openChildButton.addEventListener("optionClick", function () {
  var modal = document.querySelector('tag3-mobile-side-menu[data-name="childMenu"]');
  modal.open = true;
});

closeButton.addEventListener("optionClick", function () {
  var modal = document.querySelector('tag3-mobile-side-menu[data-name="mainMenu"]');
  modal.open = false;
});
childMenu.addEventListener("backClick", function () {
  childMenu.open = false;
});
`,
    knobs: {
      ...BasicStoryKnobs,
    },
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
  const [open, setOpen] = React.useState(false);
  const [childOpen, setChildOpen] = React.useState(false);

  return (
    <>
      <TagMobileSideMenu open={open} {{...knobs}} onClosed={() => setOpen(false)}>
        <TagMobileSideMenuOption text='Settings' icon='Settings' accent='keppel' type='button' onOptionClick={() => setChildOpen(true)} />
        <TagMobileSideMenuOption text='Disabled' icon='NoEntry' accent='keppel' type='toggle' disabled />
        <TagMobileSideMenuOption text='Sign Out' icon='Exit' accent='keppel' type='button' onOptionClick={() => setOpen(false)} />
      </TagMobileSideMenu>

      <TagMobileSideMenu open={childOpen} heading="Settings" onClosed={() => setChildOpen(false)} showBackButton>
        <Tag3Text text='Security Settings' type='feature' device='mobile'></Tag3Text>
        <TagMobileSideMenuOption text="Biometric Authentication" icon="ThumbsUp" type="toggle" accent="keppel" />
        <TagMobileSideMenuOption text="Reset Pin" icon="Refresh" accent="keppel" />
      </TagMobileSideMenu>
      <div style={{padding: "16px" }}>
        <Tag3SimpleButton
          onButtonClick={() => setOpen(true)}
        {{colour-scheme}}>
          Open
        </Tag3SimpleButton>
      </div>
    </>
  )
}
`,
    knobs: {
      ...BasicStoryKnobs,
    },
  },
};

const UserListStory: Story = {
  title: 'Option List',
  description: 'Example side menu with a list of options',

  coreComponent_v3: {
    html: `<tag3-mobile-side-menu data-name="mainMenu" {{...knobs}}>
  <tag3-text text='Switch Organisation' type='feature' device='mobile'></tag3-text>
  <tag3-mobile-side-menu-list value="1" accent="keppel">
    <tag3-mobile-side-menu-list-option value='0' heading="Access UK Ltd" label="Richard Oliver"
      image-src='https://images.pexels.com/photos/220451/pexels-photo-220451.jpeg?auto=compress&cs=tinysrgb&h=350'>
    </tag3-mobile-side-menu-list-option>
    <tag3-mobile-side-menu-list-option value='1' heading="Organisation One" label="Richard Oliver"
      image-src='https://images.pexels.com/photos/220452/pexels-photo-220452.jpeg?auto=compress&cs=tinysrgb&h=350'>
    </tag3-mobile-side-menu-list-option>
    <tag3-mobile-side-menu-list-option value='2' heading="Organisation Two" label="Richard Oliver"
      image-src='https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350'>
    </tag3-mobile-side-menu-list-option>
    <tag3-mobile-side-menu-list-option value='3' heading="Organisation Three" placeholder="RO">
    </tag3-mobile-side-menu-list-option>  
  </tag3-mobile-side-menu-list>
  <br />
  <tag3-mobile-side-menu-option text="Sign Out" icon="Exit" accent="keppel" data-name='close'></tag3-mobile-side-menu-option>
</tag3-mobile-side-menu>
<div style="padding: 16px;">
  <tag3-simple-button data-name='open' {{colour-scheme}}>Open</tag3-simple-button>
</div>
`,
    js: `var openButton = document.querySelector('tag3-simple-button[data-name="open"]');
var closeButton = document.querySelector('tag3-mobile-side-menu-option[data-name="close"]');

openButton.addEventListener("buttonClick", function () {
  var modal = document.querySelector('tag3-mobile-side-menu[data-name="mainMenu"]');
  modal.open = true;
});
closeButton.addEventListener("optionClick", function () {
  var modal = document.querySelector('tag3-mobile-side-menu[data-name="mainMenu"]');
  modal.open = false;
});
`,
    knobs: {
      ...BasicStoryKnobs,
    },
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <TagMobileSideMenu open={open} {{...knobs}} onClosed={() => setOpen(false)}>
        <Tag3Text text='Switch Organisation' type='feature' device='mobile'></Tag3Text>
        <TagMobileSideMenuList value="1" accent="keppel">
          <TagMobileSideMenuListOption value='0' heading="Access UK Ltd" label="Richard Oliver"
            imageSrc='https://images.pexels.com/photos/220451/pexels-photo-220451.jpeg?auto=compress&cs=tinysrgb&h=350'>
          </TagMobileSideMenuListOption>
          <TagMobileSideMenuListOption value='1' heading="Organisation One" label="Richard Oliver"
            imageSrc='https://images.pexels.com/photos/220452/pexels-photo-220452.jpeg?auto=compress&cs=tinysrgb&h=350'>
          </TagMobileSideMenuListOption>
          <TagMobileSideMenuListOption value='2' heading="Organisation Two" label="Richard Oliver"
            imageSrc='https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350'>
          </TagMobileSideMenuListOption>
          <TagMobileSideMenuListOption value='3' heading="Organisation Three" placeholder="RO">
          </TagMobileSideMenuListOption>  
        </TagMobileSideMenuList>
        <br />
        <TagMobileSideMenuOption text='Sign Out' icon='Exit' accent='keppel' type='button' onOptionClick={() => setOpen(false)} />
      </TagMobileSideMenu>
      <div style={{padding: "16px" }}>
        <Tag3SimpleButton
          onButtonClick={() => setOpen(true)}
        {{colour-scheme}}>
          Open
        </Tag3SimpleButton>
      </div>
    </>
  )
}
`,
    knobs: {
      ...BasicStoryKnobs,
    },
  },
};

export const TagMobileSideMenuDocs: Component = {
  type: 'component',
  name: 'mobile-side-menu',
  description: 'Renders a side menu for a mobile device',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'position',
      description: 'Whether the side menu comes in from the left or right',
      type: 'left | right',
      default: 'right',
    },
    {
      name: 'heading',
      description: 'Optional text to show as a heading on the side menu',
      type: 'left | right',
      default: 'right',
    },
    {
      name: 'show-back-button',
      description: 'Optional whether to show a back button in the heading to close the side menu',
      type: 'left | right',
      default: 'right',
    },
    {
      name: 'colour-scheme',
      description:
        'Dark mode (theme) control. Undefined for normal browser control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light',
    },
    {
      name: 'menuStyle',
      description: ' A CSS JSON string to apply to the menu element',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'opened',
      description: 'Raised when the side menu is opened',
      parameters: [],
    },
    {
      name: 'closed',
      description: 'Raised when the side menu is closed',
      parameters: [],
    },
  ],
  methods: [],
  stories: [PlaygroundStory, MultiLayerStory, UserListStory],
  childComponents: [TagMobileSideMenuOptionDocs],
};
